<oc-badge-v2
    class="fti-fly-icon-logged-in-badge"
    data-qa="fti-fly-icon-logged-in-badge"
    variant="success"
    icon="check"
    size="100">
</oc-badge-v2>
